import Phaser from 'phaser';
import { COLORS } from '../colors';
import {
  GAME_HEIGHT,
  GAME_WIDTH,
  GRID_SIZE,
  SIDEBAR,
  WORKSPACE,
  WORKSPACE_HEIGHT,
  WORKSPACE_WIDTH,
} from '../grid';

/**
 * Renders the static workspace background:
 *  - Purple outer frame
 *  - Dark rounded "blackboard" inside the frame
 *  - Subtle grid dots so students can see snap targets
 */
export function drawWorkspaceShell(scene: Phaser.Scene): void {
  const g = scene.add.graphics();
  // Outer background (already set on the game), but draw a rounded purple panel.
  const framePad = 20;
  const frameX = WORKSPACE.originX - framePad;
  const frameY = WORKSPACE.originY - framePad;
  const frameW = WORKSPACE_WIDTH + framePad * 2;
  const frameH = WORKSPACE_HEIGHT + framePad * 2;

  // Outer frame (purple)
  g.fillStyle(COLORS.frameOuter, 1);
  g.fillRoundedRect(frameX - 10, frameY - 10, frameW + 20, frameH + 20, 28);
  g.fillStyle(COLORS.frameMid, 1);
  g.fillRoundedRect(frameX - 4, frameY - 4, frameW + 8, frameH + 8, 22);

  // Inner dark workspace
  g.fillStyle(COLORS.workspaceFill, 1);
  g.fillRoundedRect(frameX, frameY, frameW, frameH, 18);
  // Subtle inner darker shadow at edges
  g.lineStyle(2, COLORS.workspaceEdge, 0.6);
  g.strokeRoundedRect(frameX + 1, frameY + 1, frameW - 2, frameH - 2, 18);
  g.setDepth(-10);

  // Faint grid dots (so students can see snap targets)
  const dots = scene.add.graphics();
  dots.fillStyle(0xffffff, 0.1);
  for (let c = 0; c < WORKSPACE.cols; c++) {
    for (let r = 0; r < WORKSPACE.rows; r++) {
      const x = WORKSPACE.originX + c * GRID_SIZE + GRID_SIZE / 2;
      const y = WORKSPACE.originY + r * GRID_SIZE + GRID_SIZE / 2;
      dots.fillCircle(x, y, 1.5);
    }
  }
  dots.setDepth(-5);

  // (Bottom of game) a small footer plate
  const footer = scene.add.graphics();
  footer.fillStyle(COLORS.frameOuter, 0.7);
  footer.fillRoundedRect(GAME_WIDTH * 0.3, GAME_HEIGHT - 32, GAME_WIDTH * 0.4, 28, 8);
  footer.setDepth(-1);

  // Right-side organ pool sidebar (the legend panel above it draws itself in
  // `drawLegend`). No header text — every pixel of vertical space inside the
  // sidebar matters because Level 11's pool holds six organs.
  const side = scene.add.graphics();
  side.fillStyle(COLORS.frameOuter, 1);
  side.fillRoundedRect(SIDEBAR.x - 6, SIDEBAR.y - 6, SIDEBAR.width + 12, SIDEBAR.height + 12, 14);
  side.fillStyle(COLORS.workspaceFill, 1);
  side.fillRoundedRect(SIDEBAR.x, SIDEBAR.y, SIDEBAR.width, SIDEBAR.height, 10);
  side.lineStyle(2, COLORS.workspaceEdge, 0.7);
  side.strokeRoundedRect(SIDEBAR.x, SIDEBAR.y, SIDEBAR.width, SIDEBAR.height, 10);
  side.setDepth(-10);
}
